export const endpoint = process.env.VUE_APP_API_DOMAIN
